// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__yUgdu","contents":"style_contents__v5veO","img":"style_img__6e5Lq"};